module.exports = __webpack_public_path__ + "static/media/BA671111-model-thumb.b50d49b5.jpg";